import React, { useState } from 'react';
import CommunityGuidelines from './CommunityGuidelines.js';
import { logOut } from '../services/auth.js';
import { submitBanAppeal } from '../services/firestore.js';
import { ShieldAlert, Send } from 'lucide-react';

export default function BannedPage({ user }) {
    const [showGuidelines, setShowGuidelines] = useState(false);
    const [appealText, setAppealText] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    // Determine if appeal is already submitted based on user data
    const [appealSubmitted, setAppealSubmitted] = useState(user?.banAppeal ? true : false);

    const handleAppealSubmit = async (e) => {
        e.preventDefault();
        if (!appealText.trim()) return;

        setIsSubmitting(true);
        try {
            await submitBanAppeal(user.uid, appealText);
            setAppealSubmitted(true);
        } catch (error) {
            console.error("Error submitting appeal:", error);
            alert("Failed to submit appeal. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    };

    if (showGuidelines) {
        return React.createElement(CommunityGuidelines, { onBack: () => setShowGuidelines(false) });
    }

    return React.createElement('div', {
        style: {
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'var(--bg-dark)',
            padding: '20px',
            color: 'white'
        }
    },
        React.createElement('div', {
            className: 'glass-panel animate-fade-in',
            style: {
                maxWidth: '500px',
                width: '100%',
                padding: '40px',
                textAlign: 'center',
                border: '1px solid #ef4444',
                background: 'rgba(239, 68, 68, 0.05)'
            }
        },
            React.createElement(ShieldAlert, { size: 60, color: '#ef4444', style: { marginBottom: '20px' } }),

            React.createElement('h1', { style: { fontSize: '32px', marginBottom: '15px', color: '#ef4444' } }, "Account Suspended"),

            React.createElement('p', { style: { fontSize: '18px', marginBottom: '20px', lineHeight: '1.5' } },
                "You have been banned for infringement of our ",
                React.createElement('button', {
                    onClick: () => setShowGuidelines(true),
                    style: {
                        background: 'none',
                        border: 'none',
                        padding: 0,
                        color: 'var(--primary)',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        fontSize: 'inherit',
                        fontWeight: 'bold'
                    }
                }, "Community Guidelines"),
                "."
            ),

            React.createElement('p', { style: { color: '#999', marginBottom: '30px', fontSize: '14px' } },
                "We take the safety of our community seriously. If you believe this ban is unwarranted and would like to appeal, you may submit a request below."
            ),

            appealSubmitted ? (
                React.createElement('div', {
                    style: {
                        background: 'rgba(16, 185, 129, 0.1)',
                        border: '1px solid #10b981',
                        borderRadius: '8px',
                        padding: '15px',
                        marginBottom: '20px',
                        color: '#10b981'
                    }
                },
                    React.createElement('strong', {}, "Appeal Submitted"),
                    React.createElement('div', { style: { fontSize: '12px', marginTop: '5px' } }, "Our team is reviewing your request.")
                )
            ) : (
                React.createElement('form', { onSubmit: handleAppealSubmit, style: { marginBottom: '20px' } },
                    React.createElement('textarea', {
                        value: appealText,
                        onChange: (e) => setAppealText(e.target.value),
                        placeholder: "Please explain why you believe your ban should be lifted...",
                        required: true,
                        style: {
                            width: '100%',
                            minHeight: '100px',
                            padding: '12px',
                            marginBottom: '10px',
                            borderRadius: '8px',
                            border: '1px solid var(--border)',
                            background: 'rgba(255,255,255,0.05)',
                            color: 'white',
                            fontSize: '14px',
                            resize: 'vertical'
                        }
                    }),
                    React.createElement('button', {
                        type: "submit",
                        disabled: isSubmitting,
                        className: 'btn',
                        style: {
                            width: '100%',
                            background: '#ec4899', // Pink button
                            color: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px'
                        }
                    },
                        isSubmitting ? "Sending..." : "Submit Appeal Request",
                        !isSubmitting && React.createElement(Send, { size: 16 })
                    )
                )
            ),

            React.createElement('button', {
                onClick: () => logOut(),
                className: 'btn-ghost',
                style: { width: '100%' }
            }, "Sign Out")
        )
    );
}
